<template>
  <v-container fill-height fluid class="pl-12 grad">
    <v-row class="mb-5">
      <v-flex sm12 md12 lg6 offset-lg1 text-center headline mt-10>
        <!-- <v-flex md12 lg6 offset-lg1>
          <v-img height="600" class="img-one" src="../../images/sketchfest.jpg"></v-img>
        </v-flex>-->
        <v-carousel
          transition="fade-transition"
          hide-delimiter-background
          cycle
          interval="4000"
          height="600"
          class="img-one"
        >
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-row>
    <v-row class="mb-5">
      <v-flex class="mt-12 headline" lg6 offset-lg1 xl6>
        <p>
          Butch Escobar is one of the most prominent comedians in the San
          Francisco Bay Area. He has performed throughout the country and for
          the troops overseas. His energetic performances and unapologetic views
          on contemporary society has made him one of the most in-demand
          comedians on the West Coast.
        </p>
        <p>
          Butch Escobar's comedy is spontaneous, truthful, and hard-hitting. He
          is a crowd favorite because his material is improvised, in-the-moment,
          and brutally honest.
        </p>
        <p>
          Butch is a featured regular at the world famous Planet Hollywood in
          Las Vegas, Cobbs Comedy Club in San Francisco, and Punch Line Comedy
          Clubs in San Francisco and Sacramento.
        </p>
        <p>
          Butch is also a requested feature for comedy legends including Joey
          Coco Diaz, Norm McDonald, Aries Spears and many more.
        </p>
      </v-flex>
    </v-row>
    <v-row class="mb-5">
      <v-col sm12 md12 lg2 offset-lg="1" class="mr-5 mb-5">
        <img
          src="https://butchescobar.com/images/be-page1A.jpg"
          lazy-src="https://butchescobar.com/images/belogo.jpg"
          class="img-two mr-5"
          height="300"
          width="300"
        />
        <img
          src="https://butchescobar.com/images/be-page1D.jpg"
          lazy-src="https://butchescobar.com/images/belogo.jpg"
          class="img-two mr-5"
          height="300"
          width="300"
        />
        <img
          src="https://butchescobar.com/images/pic4.jpg"
          lazy-src="https://butchescobar.com/images/belogo.jpg"
          class="img-two"
          height="300"
          width="300"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-flex md6 lg6 offset-lg1 class="mb-4 title">
        <p>
          <b>- Sacramento 365</b>
          <br />
          <i>
            "Butch Escobar born and raised in San Jose, California has been
            honing his comedy skills over the past decade. He is one of the most
            prominent comics in the Bay Area producing and performing multiple
            shows. His comedy is upfront and in your face. His brutal honesty
            about his life and family will leave you nodding your head with
            laughter and tears."
          </i>
        </p>
        <v-divider color="red" class="mb-5"></v-divider>
        <p>
          <b>Stand Up Santa Cruz</b>
          <br />
          <i>
            The unmistakable face of Butch Escobar resembles that of a Russian
            dancing bear that was bred for the side-show. His furious rants have
            become his trademark at such clubs as the San Jose Improv (where he
            runs his own Unfiltered Underground show).
          </i>
        </p>
        <v-divider color="red" class="mb-5"></v-divider>
        <p>
          <b>SF Sketchfest 2019</b>
          <br />
          <i>
            He frequents southern California and is a regular fixture at the
            Hollywood Improv and the world famous Comedy Store on Sunset. A
            humanitarian at heart, Butch has also travelled the world performing
            for the troops. Actor/performer/writer Butch is a triple threat that
            you will immediately become a fan of.
          </i>
        </p>
        <v-divider color="red" class="mb-5"></v-divider>
        <p>
          <b>DNA's Comedy Lab</b>
          <br />
          <i>
            If you've been at The Lab more than once you've probably seen Butch
            Escobar appear on our stage because he's one of our club favorites.
          </i>
        </p>
        <v-divider color="red" class="mb-5"></v-divider>
        <p>
          <b>Laughspin</b>
          <br />
          <i>
            Throughout one of the shows, a particular audience member wouldn’t
            stop heckling the performers. Headliner Butch Escobar didn’t like
            that. He proceeded to destroy the heckler for almost 20 minutes to
            open his set
          </i>
        </p>
        <v-divider color="red" class="mb-5"></v-divider>
        <p>
          <b>BoB 95.1 FM</b>
          <br />
          <i>
            Butch Escobar was born and raised in San Jose, California and has
            been honing his comedy skills over the past decade. Butch has an
            upcoming USO tour and an appearance on Showtime’s “The Story Behind
            the Jokes”. He is one of the most prominent comics in the Bay Area.
            His brand of comedy is based on his everyday life and is therefore
            constantly evolving.
          </i>
        </p>
        <br />
      </v-flex>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: "https://butchescobar.com/images/sketchfest.jpg",
        },
        {
          src: "https://butchescobar.com/images/be-new1.jpg",
        },
        {
          src: "https://butchescobar.com/images/be-new7.jpeg",
        },
        {
          src: "https://butchescobar.com/images/be-new8.jpg",
        },
      ],
    };
  },
};
</script>

<style scoped>
.img-one {
  border-radius: 10%;
}

.img-two {
  border-radius: 10%;
  width: 15vw;
  height: 15vw;
  object-fit: cover;
}

.grad {
  background-image: linear-gradient(to bottom right, #ffd600, #e65100);
}
</style>
